import { match } from "ts-pattern";

// 順番で権限の強さを判定している(左側が強い)ので、新規追加する場合は注意
export const roles = ["superadmin", "admin", "user"] as const;
export type Role = (typeof roles)[number];

export const roleDisplayName = (role: Role) =>
  match(role)
    .with("superadmin", () => "特権管理者")
    .with("admin", () => "管理者")
    .with("user", () => "一般ユーザー")
    .exhaustive();

export class User {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly email: string,
    public readonly role: Role,
  ) {}

  roleDisplayName(): string {
    return roleDisplayName(this.role);
  }

  // 自分の権限以上のロールは他のユーザーに割り当てられない
  selectableRoles(): Role[] {
    return roles.slice(roles.indexOf(this.role));
  }
}
